import { Amount } from "@/components";
import * as Domain from "@/domain";
import { colors } from "@/styles/colors";
import { Icon, Progress } from "@/ui";
import { FunctionComponent, ReactElement } from "react";
import styles from "./ExpenseCategory.module.scss";
import { IExpenseCategoryProps } from "./types";

export const ExpenseCategory: FunctionComponent<IExpenseCategoryProps> = (
  props: IExpenseCategoryProps
): ReactElement<IExpenseCategoryProps> => {
  const { expenseCategory, ...restProps } = props;

  return (
    <div {...restProps}>
      <div className="blockLine">
        <h2>{expenseCategory.name}</h2>
      </div>
      <div className="fullCard mainBlockBg targetAndDebtCard shadowCard marginBottom">
        <Progress.Bar
          backgroundColor={
            Domain.Color.schemas[expenseCategory.color].lightBackground
          }
          color={expenseCategory.color}
          total={expenseCategory.limitation}
          value={expenseCategory.balance}
        />
        <div className="smallCard marginBottom">
          <Icon
            backgroundColor={expenseCategory.color}
            className={styles.iconDefault}
            color={colors.palette.white}
            icon={expenseCategory.icon}
            size={32}
          />
          <div className="cardContent">
            <Amount
              className="cardContentValue"
              currency={expenseCategory.currency}
              value={expenseCategory.balance}
            />
            <Amount
              currency={expenseCategory.currency}
              value={expenseCategory.limitation}
              renderText={(formattedValue) => (
                <span className="cardContentLabel">{`из ${formattedValue}`}</span>
              )}
            />
          </div>
        </div>
        {false && (
          <ul className="btnGroupHorizontal">
            <li className="btnGroupHorizontalLi">
              <a
                href="#"
                className="mainBtn"
                onClick={() => console.log("twoLevelModal(addExpense);")}
              >
                Внести расход
              </a>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};
